import React, {Fragment} from "react";
import logo from "./img/logomin.svg";
import {Col, Row} from "react-bootstrap";
import {getMessage} from "./util";

const version = require('../package.json');


const Footer = (props) => {

    return (
        <Fragment>

            <Row className="justify-content-center EvColorBlue pb-4 pt-4 mt-4">
                <Col xs={2} sm={1} className={"text-right"}>
                    <img className="img-max-100" src={logo} alt="footer"/>

                </Col>
                <Col xs={8} md={6} className={"text-white font-weight-bold"}>
                    <Row className={"m-1"}>
                        <Col>
        {getMessage('support', props.messages)}:
                        </Col>
                    </Row>
                    <Row className={"m-1"}>
                        <Col sm={6}>
        {getMessage('support_mail', props.messages)}
                        </Col>
                        <Col sm={6}>
        {getMessage('support_phone', props.messages)}
                        </Col>
                    </Row>
                    <Row className={"m-1"}>
                        <Col >
                            <small>{getMessage('footer_message', props.messages)}</small>
                        </Col>
                    </Row>

                </Col>
            </Row>
            <Row>
                <Col className="text-right">
                    <small>© E-Voting {new Date().getFullYear()}, v. {version.version}</small>
                </Col>
            </Row>
        </Fragment>
    );
}


export default Footer;